import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const linkup = defineConnector({
  identifier: "linkup",
  name: "Linkup",
  tagLine: "Web search with source-backed answers",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: () => "https://api\\.linkup\\.so/v1/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create an account and copy your API key from the [Linkup dashboard](https://app.linkup.so).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.linkup.so/v1/credits/balance",
  },
});
